
import Vue from "vue";
import {CustomButton} from "@/utils/buttons/custom-button";
import {UserConfigService} from "@/services";
import AppCustomButtonEdit from "@/components/view-editor/NewCustomButton.vue";

export default Vue.extend({
	data(){
		return {
			items: [] as CustomButton[],
			editItem: new CustomButton(),
			showCustomButtonEdit: false
		};
	},
	props: {
		section: Boolean,
		browseName: {
			type: String
		},
		browseId: {
			type: Number
		}
	},
	computed: {
		title():string{
			if (this.section) return this.$ct("extensions.buttons").toString();
			return this.$ct("add-custom-buttons-to",{name: this.browseName}).toString();
		}
	},
	methods: {
		createNew(){
			this.editItem = new CustomButton();
			this.items?.push(this.editItem);
			this.showCustomButtonEdit = true;
		},
		async onSave(){
			this.items = this.items.map((c: CustomButton) =>
				c.uid === this.editItem.uid ? this.editItem : c
			);
			await this.updateSettings();
		},
		async updateSettings(){
			let t = UserConfigService.getCustomButtons() as any;
			t["Browse"+this.browseId] = this.items;
			await UserConfigService.setCustomButtonSettings(t);
			this.showCustomButtonEdit=false;
		},
		async deleteButton(item:CustomButton){
			let confirm = await this.$wf.confirm(this.$ct("delete-button-confirm"),
				this.$t("common.yes"), this.$t("common.no"), this.$t("common.warning"), "warning");
			if (!confirm) {
				return;
			}
			if(!this.items) return;
			this.items = this.items.filter(c => c.uid !== item.uid);
			this.updateSettings();
		},
		editClicked(item:CustomButton){
			this.editItem = item;
			this.showCustomButtonEdit=true;
		}
	},
	created(){
		this.items = UserConfigService.getCustomButtonsForBrowse(this.browseId) || [];
	},
	components: {
		AppCustomButtonEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
